/*
 * 使い方動画のポップアップ（2026-10-12）snippets/words-howto.liquid とセット
 * ・[data-wht-open="brim|size"] を押すと開く。動画は開いたときに初めて読み込む
 * ・音なし・繰り返し・その場で再生。操作バーも出す（音を出したい人・止めたい人向け）
 * ・×／背景／Esc で閉じる。閉じたら動画を止めて、押したボタンにフォーカスを戻す
 */
(function () {
  'use strict';
  var data = document.querySelector('.wht-data');
  if (!data) return;
  var box = null, vid = null, ttl = null, note = null, lastFocus = null;

  function info(kind) { return data.querySelector('[data-wht-kind="' + kind + '"]'); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  function build() {
    var cl = data.getAttribute('data-wht-close') || '閉じる';
    box = document.createElement('div');
    box.className = 'wht';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-labelledby', 'wht-title');
    box.hidden = true;
    box.innerHTML =
      '<div class="wht__panel">' +
        '<div class="wht__bar"><p class="wht__title" id="wht-title"></p>' +
        '<button type="button" class="wht__close" aria-label="' + esc(cl) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>' +
        '<div class="wht__stage"><video class="wht__vid" muted loop playsinline controls preload="none"></video></div>' +
        '<p class="wht__note"></p>' +
      '</div>';
    document.body.appendChild(box);
    vid = box.querySelector('.wht__vid');
    ttl = box.querySelector('.wht__title');
    note = box.querySelector('.wht__note');
    box.querySelector('.wht__close').addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
  }

  function onKey(e) {
    if (!box || box.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'Tab') {
      var f = Array.prototype.slice.call(box.querySelectorAll('button, video'));
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function play() { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }

  function open(kind, btn) {
    var d = info(kind);
    if (!d) return;
    if (!box) build();
    lastFocus = btn || document.activeElement;
    ttl.textContent = d.getAttribute('data-title') || '';
    var nt = d.getAttribute('data-note') || '';
    note.textContent = nt; note.hidden = !nt;
    var src = d.getAttribute('data-src'), full = d.getAttribute('data-full');
    if (vid.getAttribute('data-kind') !== kind) {
      vid.setAttribute('data-kind', kind);
      vid.poster = d.getAttribute('data-poster') || '';
      vid.onerror = null;
      if (src !== full) {
        vid.onerror = function () { if (vid.getAttribute('src') !== full) { vid.onerror = null; vid.src = full; play(); } };
      }
      vid.src = src || full;
    }
    box.hidden = false;
    document.documentElement.classList.add('wht-lock');
    document.addEventListener('keydown', onKey);
    try { vid.currentTime = 0; } catch (e) {}
    play();
    var c = box.querySelector('.wht__close'); if (c) c.focus();
  }

  function close() {
    if (!box || box.hidden) return;
    vid.pause();
    box.hidden = true;
    document.documentElement.classList.remove('wht-lock');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-wht-open]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    open(b.getAttribute('data-wht-open'), b);
  });
})();
